import Vuex from 'vuex';
import VuexORM from '@vuex-orm/core';
import database from '@/database/database';

import Address from '@/models/Address';
import Equipment from '@/models/Equipment';
import DeliveryPeriod from '@/models/DeliveryPeriod';
import Material from '@/models/Material';
import Transaction from '@/models/Transaction';
import Position from '@/models/Position';
import Price from '@/models/Price';
import { PriceRequestOutcomes, FindEquipmentstOutcomes, CreateOfferOutcomes, CreateOrderOutcomes } from '@/utils/constants';

import * as utils from '@/utils/utils';
import $ from 'jQuery';

var __requestSequenceNumber = 0;

// state
function createState(settings, strings, enums, images) {
    return {
        //server-side settings
        Product: settings.transaction.ProductType,
        DirectPriceActivated: settings.directPriceActivated,
        MoreUPFormUrl: settings.moreUPFormUrl,
        MinAmountPerUP: settings.minAmountPerUP,
        MaxAmountTotal: settings.maxAmountTotal,
        MyClimateDetailPageUrl: settings.myClimateDetailPageUrl,
        PriceInfoText: settings.priceInfoText,
        SuccessMessage: null,
        OrderNrs: [],
        OfferNr: null,
        OrderAuftraggeberNr: null,
        Strings: strings,
        Enums: enums,
        Images: images,
        PricesLoading: false,
        LoggingId: '',
        AjaxCallsPending: 0,
        EntryPageLoaded: false,
        IsPartnerLink: settings.isPartnerLink,
        PriceCalculationOutcome: null,
        FindEquipmentsOutcome: null,
        CreateOfferOutcome: null,
        CreateOrderOutcome: null,
        PricingDisabled: settings.pricingDisabled,
        UnavailableZipcodes: settings.unavailableZipcodes,
        SalesLimitFrom: settings.salesLimitFrom ? new Date(settings.salesLimitFrom) : null,
        SalesLimitUntil: settings.salesLimitUntil ? new Date(settings.salesLimitUntil) : null,
        GoalOffer: settings.goalOffer,
        GoalOrder: settings.goalOrder,
        HideOfferButtonIfPriceAvailable: settings.hideOfferButtonIfPriceAvailable,
        CrossSellingTankrevisionUrl: settings.crossSellingTankrevisionUrl,
        CouponPromo: settings.couponPromo
    }
}

// getters
const getters = {
    orderResultInfo: state => {
        return {
            "OrderNrs": state.OrderNrs,
            "AuftraggeberNr": state.OrderAuftraggeberNr
        }
    },
    isWaitingForAjax: state => {
        return state.AjaxCallsPending > 0;
    },
    isZipCodeBlocked: state => {
        let transaction = Transaction.query().with('positions.warenempfaenger').first();
        if (transaction && transaction.positions) {
            for (const pos of transaction.positions) {
                if (pos.warenempfaenger && pos.warenempfaenger.zipcode) {
                    if (state.UnavailableZipcodes.includes(pos.warenempfaenger.zipcode))
                        return true;
                }
            }
        }
        return false;
    }
}

// actions
const actions = {
    async CalculatePrices({ state, commit, dispatch, getters }) {
        if (!state.DirectPriceActivated || getters.isZipCodeBlocked) {
            //do not send anything
            return null;
        } else {

            await dispatch('ClearPrices');
            commit('setPricesLoading', true);
            commit('setPriceCalculationOutcome', null);
            let transactionData = utils.createJsTransaction(state, ++__requestSequenceNumber);
            commit('increasePendingAjaxCalls');

            //WWW-2042: tracking
            let transaction = Transaction.query().with('positions.warenempfaenger').first();
            if (transaction && transaction.positions.length > 0) {
                let firstPos = transaction.positions[0];
                if (firstPos && firstPos.warenempfaenger && window.dataLayer) {
                    //var prod;
                    //switch (state.Product) {
                    //    case 'Heizoel':
                    //        prod = "Heizöl";
                    //        break;
                    //    default:
                    //        prod = state.Product;
                    //}
                    window.dataLayer.push({
                        'event': 'preis berechnen',
                        //'item_category': prod,
                        'quantity': transaction.totalAmount,
                        'zip': firstPos.warenempfaenger.zipcode.toString()
                    });
                }
            }

            $.ajax({
                method: 'POST',
                url: '/migrolapi/' + window.CONFIG.language + '/shop/CalculatePrice',
                contentType: 'application/json',
                data: JSON.stringify(transactionData),
                dataType: 'json'
            })
                .done((response) => {
                    if (state.PricesLoading === false)
                        return; //if the loading has been cancelled in the meantime, do nothing

                    if (response.RequestSequenceNumber != __requestSequenceNumber)
                        return; //this is not the answer to the latest request

                    commit('setPriceCalculationOutcome', response.Outcome);

                    if (response.Outcome == PriceRequestOutcomes.PriceCalculated) {
                        //get transaction
                        let transaction = Transaction.query().first();

                        //set priceResponseId
                        Transaction.update({
                            id: transaction.id,
                            priceResponseId: response.PriceResponseId
                        });

                        //update price table
                        utils.populatePrices(response.Prices);
                    }

                    commit('setPricesLoading', false);
                    commit('setLoggingId', response.LoggingId);
                })
                .fail(() => {
                    commit('setPricesLoading', false);
                })
                .always(function () {
                    commit('decreasePendingAjaxCalls');
                });
        }
    },
    async ClearPrices({ commit }) {
        //get transaction
        let transaction = Transaction.query().first();
        //set loading to false
        commit('setPricesLoading', false);
        commit('setPriceCalculationOutcome', null);
        //delete all prices
        Price.deleteAll();
        //set priceResponseId to null
        await Transaction.update({
            id: transaction.id,
            priceResponseId: null
        });
        commit('setLoggingId', '');
    },
    async FindEquipments({ state, commit }) {
        return new Promise((resolve, reject) => {

            commit('setFindEquipmentsOutcome', null);

            //set selected equipment to null
            Position.update({
                equipment_id: null,
                equipment: null
            });

            //delete all equipments
            Equipment.deleteAll();

            let transactionData = utils.createJsTransaction(state, ++__requestSequenceNumber);
            commit('increasePendingAjaxCalls');

            $.ajax({
                method: 'POST',
                url: '/migrolapi/' + window.CONFIG.language + '/shop/FindEquipments',
                contentType: 'application/json',
                data: JSON.stringify(transactionData),
                dataType: 'json'
            })
                .done((response) => {
                    if (response.RequestSequenceNumber != __requestSequenceNumber)
                        return; //this is not the answer to the latest request

                    commit('setFindEquipmentsOutcome', response.Outcome);

                    if (response.Outcome == FindEquipmentstOutcomes.Success) {
                        //update equipment table
                        utils.populateEquipments(response.Equipments);
                        resolve(true);
                        return;
                    } else {
                        resolve(false);
                    }
                })
                .fail((response) => {
                    reject(response);
                })
                .always(function () {
                    commit('decreasePendingAjaxCalls');
                });
        });
    },
    async MakeOffer({ state, commit }) {
        return new Promise((resolve, reject) => {

            commit('setSuccessMessage', null);
            commit('setCreateOfferOutcome', null);
            let transactionData = utils.createJsTransaction(state, ++__requestSequenceNumber);
            transactionData.GoalOffer = state.GoalOffer;
            commit('increasePendingAjaxCalls');

            $.ajax({
                method: 'POST',
                url: '/migrolapi/' + window.CONFIG.language + '/shop/MakeOffer',
                contentType: 'application/json',
                data: JSON.stringify(transactionData),
                dataType: 'json'
            })
                .done((response) => {
                    if (response.RequestSequenceNumber != __requestSequenceNumber)
                        resolve(null); //this is not the answer to the latest request

                    commit('setCreateOfferOutcome', response.Outcome);

                    if (response.Outcome == CreateOfferOutcomes.AutomaticOffer || response.Outcome == CreateOfferOutcomes.Interaktionsformular) {
                        commit('setSuccessMessage', response.ConfirmationPageHtml);
                        commit('setOfferNr', response.OfferNr);
                    }

                    commit('setLoggingId', response.LoggingId);
                    resolve(response);
                })
                .fail((result) => {
                    reject(result);
                })
                .always(function () {
                    commit('decreasePendingAjaxCalls');
                });
        });
    },
    async MakeOrder({ state, commit }) {
        return new Promise((resolve, reject) => {

            commit('setSuccessMessage', null);
            commit('setCreateOrderOutcome', null);
            let transactionData = utils.createJsTransaction(state, ++__requestSequenceNumber);
            transactionData.GoalOrder = state.GoalOrder;
            commit('increasePendingAjaxCalls');

            $.ajax({
                method: 'POST',
                url: '/migrolapi/' + window.CONFIG.language + '/shop/MakeOrder',
                contentType: 'application/json',
                data: JSON.stringify(transactionData),
                dataType: 'json'
            })
                .done((response) => {
                    if (response.RequestSequenceNumber != __requestSequenceNumber)
                        resolve(null); //this is not the answer to the latest request

                    commit('setCreateOrderOutcome', response.Outcome);

                    if (response.Outcome == CreateOrderOutcomes.AutomaticOrder || response.Outcome == CreateOrderOutcomes.Interaktionsformular) {
                        commit('setSuccessMessage', response.ConfirmationPageHtml);
                        commit('setOrderNrs', response.OrderNrs);
                        commit('setOrderAuftraggeberNr', response.AuftraggeberNr);
                    }

                    commit('setLoggingId', response.LoggingId);
                    resolve(response);
                })
                .fail((result) => {
                    reject(result);
                })
                .always(function () {
                    commit('decreasePendingAjaxCalls');
                });
        });
    }
}

// mutations
const mutations = {
    setSuccessMessage(state, newMessage) {
        state.SuccessMessage = newMessage;
    },
    setOrderNrs(state, newOrderNrs) {
        state.OrderNrs = newOrderNrs;
    },
    setOfferNr(state, newOfferNr) {
        state.OfferNr = newOfferNr;
    },
    setOrderAuftraggeberNr(state, newAuftraggeberNr) {
        state.OrderAuftraggeberNr = newAuftraggeberNr;
    },
    setPricesLoading(state, newValue) {
        state.PricesLoading = newValue;
    },
    setLoggingId(state, newValue) {
        state.LoggingId = newValue;
    },
    increasePendingAjaxCalls(state) {
        state.AjaxCallsPending++;
    },
    decreasePendingAjaxCalls(state) {
        state.AjaxCallsPending--;
    },
    setEntryPageLoaded(state) {
        state.EntryPageLoaded = true;
    },
    setPriceCalculationOutcome(state, newValue) {
        state.PriceCalculationOutcome = newValue;
    },
    setFindEquipmentsOutcome(state, newValue) {
        state.FindEquipmentsOutcome = newValue;
    },
    setCreateOfferOutcome(state, newValue) {
        state.CreateOfferOutcome = newValue;
    },
    setCreateOrderOutcome(state, newValue) {
        state.CreateOrderOutcome = newValue;
    },
    setPricingDisabled(state, newValue) {
        state.PricingDisabled = newValue;
    },
}

export default async function createStore(settings, strings, enums, images) {

    let store = new Vuex.Store({
        plugins: [VuexORM.install(database)],
        state: createState(settings, strings, enums, images),
        getters,
        actions,
        mutations,
        strict: true
    });

    //if we have addresses, add them
    if (settings.transaction.Addresses && settings.transaction.Addresses.length > 0) {
        await Address.insert({
            data: settings.transaction.Addresses.map((address) => { return utils.createAddressFromServerAddress(address); })
        });
    }

    //if we have equipments, add them
    if (settings.transaction.Equipments && settings.transaction.Equipments.length > 0) {
        await Equipment.insert({
            data: settings.transaction.Equipments.map((equipment) => {
                return {
                    id: equipment.ID,
                    sap_id: equipment.SapID,
                    quantity: equipment.Quantity,
                    size: equipment.Size,
                    equipmentSource: equipment.EquipmentSource
                }
            })
        });
    }


    //insert delivery periods
    await DeliveryPeriod.insert({
        data: settings.transaction.DeliveryPeriods.map((period) => {
            return {
                id: period.ID,
                sortOrder: period.SortOrder,
                displayText: period.DisplayText,
                deliveryPeriodType: period.DeliveryPeriodType,
                dateFrom: period.DateFrom,
                dateUntil: period.DateUntil
            }
        })
    });

    //insert materials
    await Material.insert({
        data: settings.transaction.Materials.map((material) => {
            return {
                id: material.ID,
                name: material.Name,
                description: material.Description,
                iconUrl: material.IconUrl,
                material: material.Material,
                materialNumber: material.MaterialNumber,
                unitPrice: material.UnitUnitPriceForMaterial,
                totalPrice: material.TotalPriceForMaterial
            }
        })
    });

    //insert prices
    if (settings.prices) {
        utils.populatePrices(settings.prices);
    }

    //now create the transaction and positions
    await Transaction.insert({
        data: {
            id: 1,
            offerId: settings.transaction.OfferId,
            campaignParticipantId: settings.transaction.CampaignParticipantId,
            auftraggeber: settings.transaction.AuftraggeberId != null ? Address.find(settings.transaction.AuftraggeberId) : null,
            deliveryPeriod: settings.transaction.SelectedDeliveryPeriodId != null ? DeliveryPeriod.find(settings.transaction.SelectedDeliveryPeriodId) : null,
            material: settings.transaction.SelectedMaterialId != null ? Material.find(settings.transaction.SelectedMaterialId) : null,
            discountCode: settings.transaction.DiscountCode,
            myClimate: settings.transaction.MyClimate,
            paymentMode: settings.transaction.PaymentMode,

            positions: settings.transaction.Positions.map((pos) => {
                return {
                    id: pos.ID,
                    amount: pos.Amount,
                    warenempfaenger: pos.WarenempfaengerId != null ? Address.find(pos.WarenempfaengerId) : null,
                    regulierer: pos.ReguliererId != null ? Address.find(pos.ReguliererId) : null,
                    equipment: pos.EquipmentId != null ? Equipment.find(pos.EquipmentId) : null
                }
            })
        }
    });

    var now = new Date();
    if (store.state.SalesLimitFrom && store.state.SalesLimitUntil && now >= store.state.SalesLimitFrom && now < store.state.SalesLimitUntil) {
        const response = await fetch('/migrolapi/' + window.CONFIG.language + '/shop/IsOverSalesLimit?shopProduct=' + settings.transaction.ProductType);
        const isOverSalesLimit = await response.json();
        let pricingDisabled = isOverSalesLimit || store.state.PricingDisabled;
        store.commit('setPricingDisabled', pricingDisabled);
    }

    return store;
}